import { store } from "../../store";

// components
const ProductCatalog = () => import("../../components/ShopComponents/gtDemo/ProductCatalog/ProductCatalogWrapper-gtDemo");
//const ShoppingCart = () => import("../../components/ShopComponents/gtDemo/ShoppingCart/ShoppingCartWrapper-gtDemo");
const ShoppingCartWizard = () => import("../../components/ShopComponents/gtDemo/ShoppingCartWizard-gtDemo");
const Payment = () => import("../../components/ShopComponents/gtDemo/Payment-gtDemo");
const PendingOrderWrapper = () => import("../../components/ShopComponents/gtDemo/PendingOrder/PendingOrderWrapper-gtDemo");
const GlobalShopSelection = () => import("../../components/ShopComponents/gtDemo/ShopSelection/GlobalShopSelection-gtDemo");
const ProfilePage = () => import("../../components/ShopComponents/gtDemo/ProfilePage-gtDemo");
const UserProfilePage = () => import("../../components/ShopComponents/gtDemo/UserProfilePage-gtDemo");
const UserDataPage = () => import("../../components/ShopComponents/gtDemo/UserDataPage-gtDemo");
const GamePage = () => import("../../components/ShopComponents/gtDemo/DevSupport/GamePage-gtDemo");
const DevSupport = () => import("../../components/ShopComponents/gtDemo/DevSupport/DevSupport-gtDemo");
const Map = () => import("../../components/ShopComponents/gtDemo/DevSupport/Map-gtDemo");
const ShoppingCartStepDeliveryMethod = () => import("../../components/ShopComponents/gtDemo/ShoppingCart/_steps/ShoppingCartStepDeliveryMethod-gtDemo");
const ProductCatalogDetails = () => import("../../components/ShopComponents/gtDemo/ProductCatalog/ProductCatalogDetails-gtDemo");
const ProductCatalogList = () => import("../../components/ShopComponents/gtDemo/ProductCatalog/ProductCatalogList-gtDemo");
const ShopPreSelectionWrapper = () => import("../../components/ShopComponents/gtDemo/ShopPreSelection/ShopPreSelectionWrapper-gtDemo");
const HomePageGtDemo = () => import("../../components/ShopComponents/gtDemo/HomePage-gtDemo");
const TradingConditions = () => import("../../components/ShopComponents/gtDemo/Tenants/InfoPage-gtDemo");
const EmailVerificationGate = () => import("../../components/UtilityComponents/EmailVerificationGate.vue");
// const Checkout = () => import("../../components/ShopComponents/gt3/Checkout-gt3");


// handlers
import routeMapper from "../routeMapper";

export default {
	routes: [
		{
			path: "/",
			name: routeMapper.routeNames.Home,
			component: HomePageGtDemo,
			beforeEnter: async (to, from, next) => {

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/devSupport",
			name: routeMapper.routeNames.DevSupportDemo,
			component: DevSupport

		},
		{
			path: "/email-verification",
			name: routeMapper.routeNames.emailVerification,
			component: EmailVerificationGate
		},
		{
			path: "/map",
			name: "Map-gtDemo",
			component: Map

		},
		{
			path: "/game",
			name: routeMapper.routeNames.GamePage,
			component: GamePage

		},
		{
			path: "/shop-pre-selection",
			name: "ShopPreSelectionWrapper",
			component: ShopPreSelectionWrapper
		},
		{
			path: "/category/:categoryId",
			name: routeMapper.routeNames.productCatalog,
			component: ProductCatalog,
			children: [
				{
					// UserProfile will be rendered inside User's <router-view>
					// when /user/:id/profile is matched
					name: routeMapper.routeNames.productDetailsConfiguration,
					path: ":productId/configuration/:type/:productSelectionId",
					component: ProductCatalogDetails,
					props: true
				},
				{
					// UserProfile will be rendered inside User's <router-view>
					// when /user/:id/profile is matched
					name: routeMapper.routeNames.defaultProductCatalog,
					path: "",
					component: ProductCatalogList,
					props: true
				}
			],
			beforeEnter: async (to, from, next) => {
				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/delivery-method",
			name: routeMapper.routeNames.DeliveryMethod,
			component: ShoppingCartStepDeliveryMethod,
			beforeEnter: async (to, from, next) => {

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/checkout",
			name: routeMapper.routeNames.checkoutCart,
			component: ShoppingCartWizard,
			beforeEnter: async (to, from, next) => {

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/payment/:action",
			name: routeMapper.routeNames.payment,
			component: Payment
		},
		{
			path: "/pending-order",
			name: routeMapper.routeNames.pendingOrder,
			component: PendingOrderWrapper,
			beforeEnter: async (to, from, next) => {

				if (!store.getters.hasPendingOrder) {
					next("/");
				} else {
					next();
				}
			}
		},
		{
			path: "/shop-selection",
			name: routeMapper.routeNames.shopSelection,
			component: GlobalShopSelection,
			beforeEnter: async (to, from, next) => {

				if (store.getters.hasPendingOrder) {
					next("/pending-order");
				} else {
					next();
				}
			}
		},
		{
			path: "/user-profile",
			name: routeMapper.routeNames.userProfile,
			component: UserProfilePage
		},
		{
			path: "/profile",
			name: routeMapper.routeNames.Profile,
			component: ProfilePage
		},
		{
			path: "/user-data",
			name: routeMapper.routeNames.userData,
			component: UserDataPage
		},
		{
			path: "/terms-conditions",
			name: routeMapper.routeNames.TradingConditions,
			component: TradingConditions
		}
	]
};
